const cards = [
  {
    title: '热血格斗 · 燃爆肾上腺素',
    desc: '经典日漫格斗大作全收录，从王道热血到黑暗奇幻，下拉式畅读不间断。',
    image: 'https://readdy.ai/api/search-image?query=A%20dynamic%20action%20anime%20style%20illustration%20of%20a%20hero%20in%20battle%20pose%20with%20energy%20effects%2C%20warm%20orange%20and%20red%20color%20palette%2C%20dramatic%20lighting%2C%20manga%20cover%20style%2C%20clean%20background%2C%20professional%20anime%20art&width=800&height=533&seq=card-manga-01&orientation=landscape',
    tag: '热血',
    badge: 'HOT',
  },
  {
    title: '甜蜜恋爱 · 心动百分百',
    desc: '从校园纯爱到都市浪漫，精选日韩恋爱漫画，甜到停不下来的下拉式阅读。',
    image: 'https://readdy.ai/api/search-image?query=A%20romantic%20anime%20style%20illustration%20of%20a%20couple%20under%20cherry%20blossoms%2C%20soft%20pink%20and%20cream%20color%20palette%2C%20gentle%20atmosphere%2C%20manga%20cover%20art%20style%2C%20clean%20background%2C%20dreamy%20aesthetic&width=800&height=533&seq=card-manga-02&orientation=landscape',
    tag: '恋爱',
    badge: 'NEW',
  },
  {
    title: '悬疑推理 · 脑洞大开',
    desc: '烧脑悬疑漫画合集，每一页都是线索，下拉式阅读让推理节奏更紧凑。',
    image: 'https://readdy.ai/api/search-image?query=A%20mysterious%20anime%20style%20illustration%20with%20dark%20atmosphere%2C%20shadowy%20figure%20and%20clues%2C%20muted%20warm%20tones%20with%20contrast%2C%20suspenseful%20mood%2C%20manga%20cover%20art%2C%20clean%20composition&width=800&height=533&seq=card-manga-03&orientation=landscape',
    tag: '悬疑',
    badge: '精品',
  },
  {
    title: '爆笑喜剧 · 解压神器',
    desc: '不开心就来看搞笑漫画！日韩爆笑合集，下拉式看漫笑到停不下来。',
    image: 'https://readdy.ai/api/search-image?query=A%20funny%20anime%20style%20illustration%20with%20exaggerated%20expressions%20and%20comic%20effects%2C%20bright%20cheerful%20colors%2C%20playful%20mood%2C%20manga%20cover%20art%2C%20warm%20orange%20and%20yellow%20tones%2C%20clean%20background&width=800&height=533&seq=card-manga-04&orientation=landscape',
    tag: '搞笑',
    badge: '热门',
  },
  {
    title: '奇幻冒险 · 异世界之旅',
    desc: '穿越异世界、魔法大陆、勇者传说，下拉式全集连看，沉浸奇幻世界。',
    image: 'https://readdy.ai/api/search-image?query=A%20fantasy%20anime%20style%20illustration%20of%20a%20magical%20world%20with%20castles%20and%20dragons%2C%20vibrant%20warm%20colors%2C%20epic%20adventure%20feel%2C%20manga%20cover%20art%20style%2C%20clean%20composition%2C%20professional%20quality&width=800&height=533&seq=card-manga-05&orientation=landscape',
    tag: '奇幻',
    badge: '推荐',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">热门推荐</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-[560px] mx-auto">
            精心挑选的热门漫画推荐，下拉式阅读最佳入坑选择
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cards.map((item, idx) => (
            <div
              key={idx}
              className={`group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 transition-all duration-300 hover:border-primary-300 cursor-pointer ${idx === 0 ? 'sm:col-span-2 lg:col-span-2' : ''}`}
            >
              <div className={`relative ${idx === 0 ? 'aspect-[16/7]' : 'aspect-[16/10]'} overflow-hidden`}>
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3 flex gap-2">
                  <span className="px-2.5 py-1 rounded-full bg-background-50/90 text-foreground-800 text-xs font-medium backdrop-blur-sm">{item.tag}</span>
                  <span className="px-2.5 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-bold backdrop-blur-sm">{item.badge}</span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-base md:text-lg font-bold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors duration-200">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}